export const appBaseURL = "https://qit.auruminstitute.org";
export const keyCloakBaseURL = "https://devops.auruminstitute.org:8443";
export const downloadURL = "/api/file/downloadFile?externalReference=";
